import { gql } from "@apollo/client";

// A single tree row, loaded by id — for the pinned selected row of a column whose
// selection is not on the first page. Same fields as the rows of
// InstalledBaseNodeList and InstalledBaseRootNodeList combined, so the pinned row
// renders exactly like a list row.
export const InstalledBaseTreeItemNode = gql`
    query InstalledBaseTreeItemNode($id: ID!) {
        installedBaseNode(id: $id) {
            id
            key
            title
            isStarred
            assetCount
            childrenNodeCount
            owner {
                id
                name
            }
            access {
                id
                read
                write
                delete
            }
            nodeType {
                id
                key
                name
            }
            parentNode {
                key
                id
                title
                nodeType {
                    id
                    key
                    name
                }
            }
            assetLocation {
                id
                isInstalled
                iotConnection {
                    id
                    connectionStatus
                }
                asset {
                    id
                    serialNumber
                }
            }
            keyPath
            system {
                id
                systemType
            }
        }
    }
`;
